"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _StyledLayout = require("../StyledLayout");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable import/prefer-default-export */
var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Elements__IconWrapper",
  componentId: "sc-1alss92-0"
})(["display:inline-flex;justify-content:center;align-items:center;", ";", ";", ";", ";", ";", ";", ";svg{height:16px;min-width:16px;", ";", ";", ";", ";}", ""], _StyledLayout.spacing, function (props) {
  return props.alignLeft && (0, _styledComponents.css)(["justify-content:start;"]);
}, function (props) {
  return props.fill && (0, _styledComponents.css)(["& svg path{fill:", ";}"], props.fill ? props.fill : '');
}, function (props) {
  return props.size === 'sm' && (0, _styledComponents.css)(["height:24px;width:24px;"]);
}, function (props) {
  return props.size === 'md' && (0, _styledComponents.css)(["height:32px;width:32px;"]);
}, function (props) {
  return props.size === 'lg' && (0, _styledComponents.css)(["height:40px;width:40px;"]);
}, function (props) {
  return props.size === 'xl' && (0, _styledComponents.css)(["height:64px;width:64px;"]);
}, function (props) {
  return props.size === 'sm' && (0, _styledComponents.css)(["height:24px;min-width:24px;"]);
}, function (props) {
  return props.size === 'md' && (0, _styledComponents.css)(["height:32px;min-width:32px;"]);
}, function (props) {
  return props.size === 'lg' && (0, _styledComponents.css)(["height:40px;min-width:40px;"]);
}, function (props) {
  return props.size === 'xl' && (0, _styledComponents.css)(["height:64px;min-width:64px;"]);
}, function (props) {
  return props.link && (0, _styledComponents.css)(["&:hover{svg path{fill:", ";}}"], props.theme.iconColorHover);
});

exports.IconWrapper = IconWrapper;